export default __webpack_public_path__ + "static/media/facebook_icon.2e5b59ac.png";